import { combineReducers } from 'redux';
import show from './show';


export default combineReducers({ show });
